<div class="dialog">
  <div
    mat-dialog-title
    class="modal-header"
  >
    <h1 class="modal-title">
      <span
        [innerHtml]="data.modalTitle | translate"
      ></span>
    </h1>

    <button
      type="button"
      mat-icon-button
      class="close"
      [tabindex]="-1"
      aria-label="close dialog"
      mat-dialog-close=""
    >
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

  <div
    mat-dialog-content
    class="modal-body"
  >
    @if (!isArray) {
      <!-- Content is a string -->
      <div class="modal-main-content">
        <span
          [innerHtml]="data.modalContent | translate"
        ></span>
      </div>
    }
    @else {
      <mat-list class="modal-main-content">
        @for (content of data.modalContent; track $index) {
          <mat-list-item>
            <span
              [innerHTML]="content | translate"
            ></span>
          </mat-list-item>
        }
      </mat-list>
    }
  </div>

  <div mat-dialog-actions class="modal-footer">
    <button
      type="button"
      mat-flat-button
      color="accent"
      (click)="dialogRef.close(false)"
    >
      <span class="bold" translate="{{(data.modalButton) ? data.modalButton : 'TRANS__ALERT_DIALOG__OK'}}">
        {{ ((data.modalButton) ? data.modalButton : 'TRANS__ALERT_DIALOG__OK') | translate }}
      </span>
    </button>
  </div>
</div>

